/**
 * Main Site Bootstrap.
 */

$(document).ready(() => {

  window.siteManager = new window.SiteController(window.siteConfig);

});
